import type { FunctionComponent } from 'react';
import { Price, Text } from '@kanda-libs/ks-design-library';

import { CLASS_NAMES } from './constants';
import useCreditCosts from './useCreditCosts';

interface CreditCostsInputProps {
  isLoading: boolean;
}

const CreditCosts: FunctionComponent<CreditCostsInputProps> = function ({
  isLoading,
}) {
  const { creditLine, interest, fee, terms, monthly } = useCreditCosts();

  return (
    <div className={CLASS_NAMES.container}>
      <div className={CLASS_NAMES.item}>
        <Text
          text="Loan amount"
          className={CLASS_NAMES.heading}
          isLoading={isLoading}
        />
        <Price
          amount={creditLine}
          poundsClassName={CLASS_NAMES.pounds}
          centsClassName={CLASS_NAMES.cents}
          isLoading={isLoading}
        />
      </div>
      <div className={CLASS_NAMES.separator} />
      <div className={CLASS_NAMES.wrapper}>
        <div className={CLASS_NAMES.item}>
          <Text
            text="interest"
            className={CLASS_NAMES.heading}
            isLoading={isLoading}
          />
          <Text
            text={interest}
            className={CLASS_NAMES.value}
            isLoading={isLoading}
          />
        </div>
        <div className={CLASS_NAMES.item}>
          <Text
            text="total fee"
            className={CLASS_NAMES.heading}
            isLoading={isLoading}
          />
          <Price
            amount={fee}
            poundsClassName={CLASS_NAMES.pounds}
            centsClassName={CLASS_NAMES.cents}
            isLoading={isLoading}
          />
        </div>
        <div className={CLASS_NAMES.item}>
          <Text
            text="terms"
            className={CLASS_NAMES.heading}
            isLoading={isLoading}
          />
          <Text
            text={terms}
            className={CLASS_NAMES.value}
            isLoading={isLoading}
          />
        </div>
        <div className={CLASS_NAMES.item}>
          <Text
            text="monthly"
            className={CLASS_NAMES.heading}
            isLoading={isLoading}
          />
          <Price
            amount={monthly}
            poundsClassName={CLASS_NAMES.pounds}
            centsClassName={CLASS_NAMES.cents}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

CreditCosts.displayName = 'CreditCosts-view';

export default CreditCosts;
